import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Theme } from '../service/AutoTheme';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.css']
})
export class ToggleComponent {
  @Input() selected : boolean=true;
  @Input() selected2 : boolean=false;
  @Input() selected3 : boolean=false;
  /* @Input() value1  : string = "play_arrow";
  @Input() value2  : string = "call";
  @Input() value3 : string = "phone_in_talk";
  @Input() value4 : string = "touch_app";
  public autoss:string="scatter_plot" */
  
  public  menu :  boolean;  
  public value1  : string = "play_arrow";
  public value2  : string = "pause";
  public value3  : string = "stop";
  @Output() OnChange: EventEmitter<number> = new EventEmitter();

  constructor( public theme:Theme ) { }
  ngOnInit() {

    this.theme.showmenu.subscribe(res=>{
        this.menu= res;
    });
  }

  OnClick(event:number)
  {
    console.log(event);
    this.OnChange.emit(event);
  }

}
